import PropTypes from 'prop-types';
import React, { useContext, useEffect, useRef } from 'react';
import { Form as FinalForm } from 'react-final-form';
import { handleProps } from './utils';
import { randomUUID } from 'utils';
import { FormContext } from 'contexts';

/**
 * We created a wrapper around the react-final-form `Form` component because
 * we wanted to expand it with functionality of being able to prevent the
 * page unload (changing the page) if there are unsaved changes.
 * To be able to do that we expanded `Form` with a `preventUnload` property, which, if
 * set to `true` would check whether the form has `dirty` fields.
 * it would raise a modal if there are indeed such fields, asking the user to confirm its choice.
 * All other props (besides the `preventUnload`) will be passed to the react-final-form
 * component. Expected behavior is same as the one of the library component, with added
 * "ask user before changing the page if there are unsaved changes" functionality.
 * when `forcePreventUnload` is true, we will raise a dialog on any attempted page change,
 * regardless of the `dirty` value
 **/
export const Form = ({ preventUnload, forcePreventUnload, ...formProps }) => {
  const idRef = useRef(randomUUID());
  const setDirty = useContext(FormContext);

  useEffect(() => {
    return () => {
      setDirty(idRef.current, false);
    };
  });

  return (
    <FinalForm
      {...handleProps(
        formProps,
        preventUnload,
        forcePreventUnload,
        idRef,
        setDirty
      )}
    />
  );
};

Form.propTypes = {
  ...FinalForm.propTypes,
  preventUnload: PropTypes.bool,
  forcePreventUnload: PropTypes.bool,
};
